export const AI_ENABLED_NAMESPACES = ["worksheet_wizard", "text_editor"];

export const isAiEnabledTool = (namespace: string): boolean => {
  return AI_ENABLED_NAMESPACES.includes(namespace);
};
